import { jsx } from 'react/jsx-runtime';
import { TITLE_SECTION_HEIGHT, COMMENT_SECTION_HEIGHT, TAGS_SECTION_HEIGHT } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { useResourcesUiStore } from '../../stores/useResourcesUiStore.js';
import { useMemo, createContext, useContext } from 'react';

const ResourcesPreviewUiConfigContext = /* @__PURE__ */ createContext(void 0);
const ResourcesPreviewUiConfigProvider = ({ uiContext = "global", children }) => {
  const appearence = useResourcesUiStore(uiContext);
  const minusBaseHeight = useMemo(() => {
    const gap = 12;
    const itemsToReduce = [
      appearence?.hideTitle ? TITLE_SECTION_HEIGHT : 0,
      appearence?.hideComment ? COMMENT_SECTION_HEIGHT : 0,
      appearence?.hideTags ? TAGS_SECTION_HEIGHT : 0
    ];
    const reductionForItems = itemsToReduce.reduce((acc, curr) => acc + (curr ? curr + gap : 0), 0);
    return reductionForItems;
  }, [
    appearence
  ]);
  return /* @__PURE__ */ jsx(ResourcesPreviewUiConfigContext.Provider, {
    value: {
      appearence,
      minusBaseHeight
    },
    children
  });
};
const useResourcePreviewUiConfigContext = () => useContext(ResourcesPreviewUiConfigContext);

export { ResourcesPreviewUiConfigProvider, useResourcePreviewUiConfigContext };
//# sourceMappingURL=resourcePreviewUiConfigContext.js.map
